import React, {Suspense, useEffect, useState} from "react";
import {ProvideAuth} from "./services/use-auth.js";
import {BrowserRouter as Router} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import './assets/styles/main.scss';
import Routes from "./Routes";

export default function App () {
    const [appData, setAppData] = useState(null);

    useEffect(() => {
        fetch('/api/v1/spa/appData')
            .then(res => res.json())
            .then(
                (result) => {
                    setAppData(result);
                }
            )
    }, [])

    return (
        appData ?
            <Suspense fallback="loading">
                <ProvideAuth user={appData.user}>
                    <Router>
                        <Header />
                        <div id="main">
                            <Routes />
                        </div>
                        <Footer />
                    </Router>
                </ProvideAuth>
            </Suspense> :
            <></>
    );
}
